import { F } from "./primitives";

/* v2.87 · Motor-branch NEC 430 inputs — extracted from Calculators.jsx.
   Rendered when `form.circuit_type === "motor_branch"`. */
export function MotorBranchInputs({ form, patchForm }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-4 p-3 border border-[#00E5FF]/20 bg-[#00E5FF]/5"
         data-testid="cond-motor-branch-fields">
      <F label="Motor OCPD type">
        <select value={form.motor_protection}
          onChange={(e) => patchForm({ motor_protection: e.target.value })}
          className="w-full bg-black/40 border border-white/10 px-2 py-2 text-sm font-mono focus:border-[#00E5FF] outline-none"
          data-testid="cond-motor-protection"
          title="NEC Table 430.52 — max OCPD as % of motor FLC. Inverse-time breaker 250 %, dual-element fuse 175 %, non-time-delay fuse 300 %, instantaneous-trip breaker 800 %.">
          <option value="inverse_time_breaker">Inverse-time breaker · 250 %</option>
          <option value="dual_element_fuse">Dual-element fuse · 175 %</option>
          <option value="non_time_delay_fuse">Non-time-delay fuse · 300 %</option>
          <option value="instantaneous_breaker">Instantaneous / MCP · 800 %</option>
        </select>
      </F>
      <F label="Motor service factor">
        <select value={form.motor_service_factor}
          onChange={(e) => patchForm({ motor_service_factor: Number(e.target.value) })}
          className="w-full bg-black/40 border border-white/10 px-2 py-2 text-sm font-mono focus:border-[#00E5FF] outline-none"
          data-testid="cond-motor-sf"
          title="NEC 430.32(A)(1): overload relay set to 125 % of FLC for motors marked with SF ≥ 1.15 or 40 °C rise, else 115 %.">
          <option value={1.15}>1.15 (or 40 °C rise) → OL 125 %</option>
          <option value={1.0}>&lt; 1.15 → OL 115 %</option>
        </select>
      </F>
    </div>
  );
}
